import type { Fixture, ProviderFixtureBundle } from './api';

export type MatchGroup = 'PREVIOUS' | 'LIVE' | 'NEXT';

const FINISHED_PROVIDER = new Set(['FT', 'AET', 'PEN', 'FINISHED', 'FULL_TIME']);
const LIVE_PROVIDER = new Set(['LIVE', '1H', '2H', 'HT', 'ET', 'PEN_LIVE', 'IN_PLAY']);

export function providerMatchGroup(bundle: ProviderFixtureBundle, nowMs = Date.now()): MatchGroup {
  const status = bundle.fixture.status.toUpperCase();
  if (FINISHED_PROVIDER.has(status)) return 'PREVIOUS';
  if (LIVE_PROVIDER.has(status) || bundle.fixture.minute !== null) return 'LIVE';
  if (bundle.startingAt) {
    const kickoff = Date.parse(bundle.startingAt);
    if (Number.isFinite(kickoff) && kickoff < nowMs && bundle.fixture.homeScore !== null && bundle.fixture.awayScore !== null) return 'PREVIOUS';
  }
  return 'NEXT';
}

export function fplMatchGroup(fixture: Fixture): MatchGroup {
  if (fixture.finished) return 'PREVIOUS';
  if (fixture.started) return 'LIVE';
  return 'NEXT';
}

export function groupProviderFixtures(fixtures: ProviderFixtureBundle[], nowMs = Date.now()): Record<MatchGroup, ProviderFixtureBundle[]> {
  const groups: Record<MatchGroup, ProviderFixtureBundle[]> = { PREVIOUS: [], LIVE: [], NEXT: [] };
  for (const fixture of fixtures) groups[providerMatchGroup(fixture, nowMs)].push(fixture);
  return groups;
}

export function groupFplFixtures(fixtures: Fixture[]): Record<MatchGroup, Fixture[]> {
  const groups: Record<MatchGroup, Fixture[]> = { PREVIOUS: [], LIVE: [], NEXT: [] };
  for (const fixture of fixtures) groups[fplMatchGroup(fixture)].push(fixture);
  return groups;
}
